import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Advertiser } from 'src/app/models/advertiser';
import { AdvertiserService } from 'src/app/services/advertiser.service';

@Component({
    selector: 'app-product-by-advertiser',
    templateUrl: './product-by-advertiser.component.html',
    styleUrls: ['./product-by-advertiser.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductByAdvertiserComponent implements OnInit {

  advertiserName!: string;
  advertiser!: Advertiser;

  constructor(private activatedRoute: ActivatedRoute, private advertiserService: AdvertiserService) {
    this.advertiserName = activatedRoute.snapshot.params.advertiserName;
  }

  ngOnInit(): void {
    if (!this.advertiser) {
      this.advertiserService.getAdvertiserByName(this.advertiserName).subscribe (advertiser => {
        this.advertiser = advertiser;
      });
    }
  }
}
